import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import PropTypes from 'prop-types';
import { uploadImageRequest } from '../../services/cms/uploadServiceRequest';

// Import bản build custom từ thư mục ckeditor5 của dự án
const Editor = require('../../ckeditor5/build/ckeditor');

class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          uploadImageRequest(file)
            .then((result) => {
              if (result && result.url) {
                resolve({
                  default: result.url,
                });
              } else {
                reject('Upload failed');
              }
            })
            .catch((err) => {
              reject(err);
            });
        })
    );
  }

  abort() {
    // Optional
  }
}

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader);
  };
}

const editorConfiguration = {
  toolbar: {
    items: [
      'sourceEditing',
      'showBlocks',
      '|',
      'undo',
      'redo',
      '|',
      'heading',
      '|',
      'fontFamily',
      'fontSize',
      'fontColor',
      'fontBackgroundColor',
      'highlight',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      '|',
      'alignment',
      '|',
      'link',
      'imageInsert',
      'mediaEmbed',
      'htmlEmbed',
      'insertTable',
      'blockQuote',
      'horizontalLine',
      'pageBreak',
      'specialCharacters',
      '|',
      'bulletedList',
      'numberedList',
      'todoList',
      'outdent',
      'indent',
      '|',
      'codeBlock',
      'findAndReplace',
    ],
    shouldNotGroupWhenFull: true,
  },
  // Cho phép tất cả các thẻ HTML và thuộc tính để không bị editor tự động xóa (giống trình soạn thảo code)
  htmlSupport: {
    allow: [
      {
        name: /.*/,
        attributes: true,
        classes: true,
        styles: true,
      },
    ],
  },
  htmlEmbed: {
    showPreviews: true,
  },
  removePlugins: ['Title'],
  placeholder: 'Nhập nội dung bài viết (Hỗ trợ HTML/Source code)...',
  extraPlugins: [MyCustomUploadAdapterPlugin],
};

const CustomEditor = ({ initialData, onChange }) => {
  return (
    <div className="ck-editor-container">
      <CKEditor
        editor={Editor}
        config={editorConfiguration}
        data={initialData || ''}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
      />
      <style>{`
        .ck-editor__editable_inline {
          min-height: 400px;
          max-height: 500px;
          overflow-y: auto;
        }
        .ck-editor-container {
          width: 100%;
          border-radius: 8px;
          overflow: hidden;
          border: 1px solid #d9d9d9;
        }
        .ck.ck-editor__main > .ck-editor__editable {
          background: #fff;
        }
        .ck.ck-toolbar {
          border-top: none;
          border-left: none;
          border-right: none;
          background: #f9f9f9;
        }
      `}</style>
    </div>
  );
};

CustomEditor.propTypes = {
  initialData: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default CustomEditor;
